var TabsBlock = /** @class */ (function () {
    function TabsBlock(element) {
        this.tabsBlock = element;
        this.tabTargetToggles = this.tabsBlock.querySelectorAll('[data-tab-target]');
        this.tabItems = this.tabsBlock.querySelectorAll('[data-tab-item]');
        this.childTabToggles = this.tabsBlock.querySelectorAll('[data-tab-child-item]');
        this.addEventListeners();
    }
    TabsBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.tabTargetToggles.forEach(function (tabTargetToggle) {
            tabTargetToggle.addEventListener('click', function (event) {
                var currentTarget = event.currentTarget;
                var tabTarget = currentTarget.dataset.tabTarget;
                _this.tabTargetToggles.forEach(function (tabTargetToggle) {
                    tabTargetToggle.classList.remove('active');
                    // if this item - add active class
                    if (tabTargetToggle === currentTarget) {
                        tabTargetToggle.classList.add('active');
                    }
                });
                _this.tabItems.forEach(function (tabItem) {
                    tabItem.classList.remove('active');
                    if (tabItem.dataset.tabItem === tabTarget) {
                        tabItem.classList.add('active');
                    }
                });
            });
        });
        this.childTabToggles.forEach(function (childTabToggle) {
            childTabToggle.addEventListener('click', function (event) {
                var currentTarget = event.currentTarget;
                var tabWrapper = currentTarget.parentElement.parentElement;
                var tabTarget = currentTarget.dataset.tabChildItem;
                tabWrapper.querySelectorAll('[data-tab-child-item]').forEach(function (childTabToggle) {
                    childTabToggle.classList.remove('active');
                    // if this item - add active class
                    if (childTabToggle === currentTarget) {
                        childTabToggle.classList.add('active');
                    }
                });
                tabWrapper.querySelectorAll('[data-tab-child-content]').forEach(function (childTabItem) {
                    childTabItem.classList.remove('active');
                    if (childTabItem.dataset.tabChildContent === tabTarget) {
                        childTabItem.classList.add('active');
                    }
                });
            });
        });
    };
    return TabsBlock;
}());
export default TabsBlock;
